import React, { useState, useCallback  } from 'react';
import Headerdash from "./head";
import Sidebar from "./sidebar";
import BillingPricing from "../StatusPages/ChangePlanPricing";

const billingData = [
  {
    billingDate: "24/05/2024",
    nextBillingDate: "24/05/1995",
    plan: "Starter",
  },
  {
    billingDate: "24/05/2024",
    nextBillingDate: "04/11/1980",
    plan: "Basic",
  },
  {
    billingDate: "24/05/2024",
    nextBillingDate: "24/05/1995",
    plan: "Premium",
  },
];

export default function Billing() {

  const [allSubscriptionData, setAllSubscriptionData] = useState(null);

  const handleAllSubscriptionData = useCallback((data) => {
    setAllSubscriptionData(data);
  }, []);

  console.log("allSubscriptionData",allSubscriptionData)
  return (
    // billing Section
    <section>
      <Headerdash />
      <Sidebar />
      <div className="pt-28">
        <h3 className="max-w-5xl md:ml-80 font-bold text-2xl text-gray-700 p-3 mx-3 mb-10 border-b-2">
          Plans and Billing
        </h3>
        <BillingPricing onAllSubscriptionData={handleAllSubscriptionData} />
        <h3 className="md:ml-80 font-semibold text-sm text-gray-600 p-3 mx-3 mb-3">
          Purchase History 
        </h3>
        <div className="mx-5 max-w-5xl md:ml-80">
          <table className="min-w-full divide-y-2 divide-gray-200 text-sm bg-slate-50">
            <thead className="ltr:text-left rtl:text-right">
              <tr className="bg-gray-100">
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Billing Date
                </th>
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Next Billing Date
                </th>
                <th className="whitespace-nowrap px-4 py-3 font-medium text-gray-900">
                  Plan
                </th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>

            {allSubscriptionData ? (
              <tbody className="divide-y divide-gray-200">
                {allSubscriptionData.map((entry, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap px-4 py-3 font-medium text-gray-900 text-center">
                      {entry.subscriptionStartDate}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-gray-700 text-center">
                      {entry.subscriptionEndDate}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-gray-700 text-center">
                      {entry.beforePlan}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3">
                      <a className="inline-block rounded bg-gray-800 px-4 py-2 text-xs font-medium text-white hover:bg-black">
                        {entry.subscriptionStatus}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    Loading...
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
    </section>
  );
}
